function getLocalModules() {
  return [
    {
      key: 'dashboard',
      label: 'Dashboard',
      icon: 'fa-board',
      path: '/',
      divider: false,
    },
    {
      key: 'users',
      label: 'Usuarios',
      icon: 'fa-users',
      divider: false,
      subMenu: [
        { key: 'users/add', label: 'Agregar', path: '/users/add' },
        { key: 'users/all', label: 'Todos los usuarios', path: '/users/all' },
      ],
    },
    
    { 
        key: 'clients', 
        label: 'Clientes', 
        icon: 'fa-user', 
        divider: false,
        subMenu: [
            { key: 'clients/all', label: 'Todos los clientes', path: '/clients/all' },
        ],
    },
    
    {
      key: 'catalogs',
      label: 'Catálogos',
      icon: 'fa-folder-open',
      divider: false,
      subMenu: [
        { key: 'catalogs/membershipTypes', label: 'Tipos de membresias', path: '/memberships/all' },
        { key: 'catalogs/specialties', label: 'Especialidades', path: '/specialties/all' },
      ],
    },

    { 
      key: 'splash', 
      label: 'Splash', 
      icon: 'fa-play', 
      path: '/splash',
      divider: false,
    },
    { 
      key: 'carousel', 
      label: 'Carrusel', 
      icon: 'fa-images', 
      path: '/carousel',
      divider: false,
    },  
    {
      key: 'reports',
      label: 'Reportes',
      icon: 'fa-chart-line',
      divider: false,
      subMenu: [
        // { key: 'reports/clients', label: 'Clientes', path: '/reports/clients' },
        // { key: 'reports/plans', label: 'Planes', path: '/reports/plans' },
        { key: 'reports/specialists', label: 'Especialistas', path: '/reports/specialists' },
        { key: 'reports/patients', label: 'Pacientes', path: '/reports/patients' },
      ],
    },
  ];
}

export async function getModules() {
    return getLocalModules();
}
